import React, {useState, Fragment, useCallback, useReducer, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { Card, CardBody, CardHeader, Form, FormGroup, Input,Row, Col, Label  } from 'reactstrap';
import { Breadcrumbs, Btn, H4, } from '../../../AbstractElements';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import SweetAlert from 'sweetalert2';
import { ChangeInStatus, InquiryList ,loginuserdata} from '../../../apiController';


const initialState = {
  approve: '',
  cancel:'',
  id:''
};

const AppointmentInquiry = () =>{

 
  const [inquiryList, setInquiryList] = useState([]);
  
  const userId = loginuserdata.user.id;




    // const [data, setData] = useState(treatmentplan);

    const plantableColumns = [
      {
          name: '#',
          selector: row => row['ind'],
          sortable: true,
          center: false,
      },
      {
          name: 'Patient Name',
          selector: row => row['patient'],
          sortable: true,
          center: true,
      },
      {
          name: 'Reason',
          selector: row => row['reason'],
          sortable: true,
          center: true,
      },
      {
          name: 'Requested Date',
          selector: row => row['date'],
          sortable: true,
          center: true,
      },
  ];
  
   const inquiryValues = 
   inquiryList.map((row, ind)=>

      ({
          ind: ind+1,
        //   id: row.id,
          patient: `${row.first_name} ${row.surname}`,
          reason: row.enquiry,
          date: row.date,
      })
    
    );


    useEffect(()=>{
      fetchInquiryList(userId)
    },[])

   

   

    const handleApproval = async () => {
      const result = await SweetAlert.fire({
        title: 'Are you sure you want to make changes?',
        cancelButtonText: 'No!',
        confirmButtonText: 'Yes!',
        reverseButtons: true,
        showCancelButton: true,
      });
    
      if (result.isConfirmed) {
        handleInquiryStatus()
      }
    };

    const fetchInquiryList = async (id) => {
      try {
        const response = await InquiryList({
          role: "admin_status",
          id: id,
        });
        if (response) {
          const notification = response.notifications;
          setInquiryList(notification);
        }
      } catch (error) {
        toast.error("An error occurred during login", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    };

    const handleInquiryStatus = () => {
      changeInStatus(userId)
    }
    
    
    const changeInStatus = async (id) => {
      try {
        const response = await ChangeInStatus({
          role: "doctor_status",
          id: id,
        });
        if (response.status === true) {
          toast.success("Status Updated Successfully!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } catch (error) {
        toast.error("An error occurred during login", {
          position: toast.POSITION.TOP_CENTER,
        });
      }  finally {
        fetchInquiryList(userId)
      }
    };

  console.log(inquiryList)
  return (
    <>
      <Breadcrumbs mainTitle='Appointment Inquiry' parent='Dashboard' title='appointmentinquiry' />
    <Card>
      {/* <CardHeader className='card-no-border'>
        <div className='header-top'>
          <Fragment>
  <div className="search">
    <Form className="theme-form">
      <FormGroup className="form-group">
        <div className="input-group">
          <Input
            className="form-control"
            type="text"
            placeholder="search"
            defaultValue={searchKeyword}
            onChange={(e) => handleSearchKeyword(e.target.value)}
          />
          <div className="input-group-append">
            <span className="input-group-text">
              <i className="fa fa-search"></i>
            </span>
          </div>
        </div>
      </FormGroup>
    </Form>
  </div>
</Fragment>
          <div className='card-header-right-icon'>
          </div>
        </div>
      </CardHeader> */}
      <CardBody className='pt-0 campaign-table'>
        <div className='recent-table table-responsive currency-table'>
        <Fragment>
        
                <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Patient Inquired For Appointment</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: () => handleApproval() }}>Mark as Read</Btn>
                </div>
            
        <DataTable
                data={inquiryValues}
                columns={plantableColumns}
                striped={true}
                center={true}
                pagination
                // selectableRows
                // onSelectedRowsChange={handleRowSelected}
                // clearSelectedRows={toggleDelet}
            />
            </Fragment>
        </div>
      </CardBody>
    </Card>
    </>
  );
}

export default AppointmentInquiry